export default __webpack_public_path__ + "static/media/1124.6fc0c629.png";